import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=2ef4206e&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=2ef4206e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4206e",
  null
  
)

export default component.exports